define.alias("ember-intl/helpers/format-date", "settings/helpers/format-date");